import { AxiosResponse } from 'axios'
import { ISignatureApiResponse } from 'src/system/content/api/ISignatureApiResponse'
import { SignatureDocument } from 'src/system/content/schemas/signature'
import ILocalContentService from 'src/system/content/services/ILocalContentService'
import IRemoteContentService from 'src/system/content/services/IRemoteContentService'
import ISignatureService from 'src/system/content/services/ISignatureService'

export class SignatureService implements ISignatureService {
  constructor(private localContentService: ILocalContentService, private remoteContentService: IRemoteContentService) {
    //
  }

  async fetchAllSignatures(): Promise<void> {
    const response: AxiosResponse<ISignatureApiResponse[]> = await this.remoteContentService.request(
      'GET',
      '/api/signature'
    )

    const responseSignatures = response.data.map((signature) => ({
      id: signature.id.toString(),
      user: signature.user_id.toString(),
      name: signature.name,
      title: signature.title,
      telephone: signature.telephone,
      email: signature.email,
      image: signature.image,
      linkedin: signature.linkedin,
      bio: signature.bio,
      specialisms: signature.specialisms,
    }))

    const db = this.localContentService.getDatabase()

    const storedIds = (await db.signatures.find().exec()).map((signature) => signature.id)
    const responseIds = responseSignatures.map((signature) => signature.id)

    const idsToDelete = storedIds.filter((id) => !responseIds.includes(id))

    await Promise.all([db.signatures.bulkRemove(idsToDelete), db.signatures.bulkUpsert(responseSignatures)])
  }

  async delete(id: string): Promise<void> {
    await this.remoteContentService.request('POST', '/api/signature/delete', { id: Number(id) })
  }

  async createSignature(signature: SignatureDocument): Promise<void> {
    await this.remoteContentService.request('POST', '/api/signature/create', signature)
  }

  async updateSignature(signature: SignatureDocument): Promise<void> {
    await this.remoteContentService.request('POST', '/api/signature/update', signature)
  }
}
